module.exports = __webpack_public_path__ + "img/FR14228.ab6a4550.svg";